import { render, staticRenderFns } from "./MlBranch.vue?vue&type=template&id=af38cb18&scoped=true"
import script from "./MlBranch.vue?vue&type=script&lang=js"
export * from "./MlBranch.vue?vue&type=script&lang=js"
import style0 from "./MlBranch.vue?vue&type=style&index=0&id=af38cb18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af38cb18",
  null
  
)

export default component.exports